"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Player = exports.PlayIcon = exports.PlayButton = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')({
  display: 'flex',
  position: 'relative'
});
const PlayButton = exports.PlayButton = (0, _mui.styled)('div', {
  name: 'Video',
  slot: 'PlayButton',
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isPlaying
}) => ({
  display: isPlaying ? 'none' : 'block',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  webkitTransform: 'translate(-50%, -50%)',
  zIndex: '1'
}));
const PlayIcon = exports.PlayIcon = (0, _mui.styled)(_icons.ArrowRight, {
  name: 'Video',
  slot: 'PlayIcon'
})(({
  theme
}) => ({
  color: theme.palette.common.white,
  fontSize: '5.4rem',
  left: '50%',
  position: 'absolute',
  top: '50%',
  transform: 'translate(-50%, -50%)'
}));
const Player = exports.Player = (0, _mui.styled)('video', {
  name: 'Video',
  slot: 'Player',
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isPlaceholderVisible
}) => ({
  display: isPlaceholderVisible ? 'none' : 'unset',
  maxWidth: '100%',
  position: 'relative'
}));
//# sourceMappingURL=styles.js.map